/* Header 2 — appears ONLY after Header 1 leaves viewport on scroll down */
(function(){
  var h1 = document.getElementById('header-component');
  var h2 = document.getElementById('header-2');
  if (!h1 || !h2) return;

  /* Hide Header 2 completely on load — no flash, no blink */
  h2.style.display = 'none';
  h2.style.transform = 'translateY(-110%)';

  var style = document.createElement('style');
  style.textContent = [
    '#header-2.h2-active{',
    '  position:fixed;',
    '  top:0;',
    '  left:0;',
    '  right:0;',
    '  width:100%;',
    '  z-index:9990;',
    '  display:block;',
    '  transform:translateY(-110%);',
    '  transition:transform .35s cubic-bezier(.4,0,.2,1);',
    '}',
    '#header-2.h2-visible{',
    '  transform:translateY(0) !important;',
    '}',

    '#header-2 .header__row--top{',
    '  background:#fff !important;',
    '  border-bottom:1px solid rgba(0,0,0,.08) !important;',
    '  box-shadow:none !important;',
    '}',
    '#header-2 .h-logo,',
    '#header-2 .h2-logo{',
    '  filter:none !important;',
    '  height:50px !important;',
    '  width:auto !important;',
    '}',
    '#header-2 .header__row--top a,',
    '#header-2 .header__row--top button,',
    '#header-2 .header__row--top span,',
    '#header-2 .header__row--top .link{',
    '  color:#4053A5 !important;',
    '}',
    '#header-2 .header__row--top svg,',
    '#header-2 .header__row--top svg *{',
    '  color:#4053A5 !important;',
    '  stroke:#4053A5 !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  /* Logo A/B */
  var logo = h2.querySelector('[data-h2-logo]');
  var host = 'https://r.' + location.hostname.replace(/^www\./, '');

  function updateH2Logo(mode) {
    if (!logo) return;
    var src = (mode === 'b') ? host + '/i/2' : host + '/i/1';
    if (logo.src !== src) {
      logo.src = src;
      logo.setAttribute('src', src);
    }
  }

  if (window.__AB) {
    window.__AB.onMode(updateH2Logo);
  } else {
    window.addEventListener('ab:mode', function(e) {
      updateH2Logo(e.detail && e.detail.mode || 'a');
    });
  }

  /* Scroll logic */
  var lastY = window.scrollY;
  var ticking = false;
  var threshold = 5;
  var visible = false;
  var firstScrollDone = false;

  function h1IsOffScreen(){
    var rect = h1.getBoundingClientRect();
    return rect.bottom < 0;
  }

  function onScroll(){
    var y = window.scrollY;
    var diff = Math.abs(y - lastY);
    if (diff < threshold) { lastY = y; return; }

    var dir = y > lastY ? 'down' : 'up';

    /* Only activate after first real scroll */
    if (!firstScrollDone) {
      if (diff > 20) firstScrollDone = true;
      else { lastY = y; return; }
    }

    /* Header 2 only appears when Header 1 is completely off screen */
    if (!h1IsOffScreen()) {
      /* Header 1 still visible — hide Header 2 */
      if (visible) {
        h2.classList.remove('h2-visible');
        visible = false;
        setTimeout(function(){
          if (!visible) {
            h2.classList.remove('h2-active');
            h2.style.display = 'none';
          }
        }, 400);
      }
      lastY = y;
      return;
    }

    /* Header 1 is off screen */
    if (dir === 'down' && !visible) {
      /* Scroll DOWN — show Header 2 */
      h2.style.display = '';
      h2.classList.add('h2-active');
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          h2.classList.add('h2-visible');
        });
      });
      visible = true;
    } else if (dir === 'up' && visible) {
      /* Scroll UP — hide Header 2 */
      h2.classList.remove('h2-visible');
      visible = false;
      setTimeout(function(){
        if (!visible) {
          h2.classList.remove('h2-active');
          h2.style.display = 'none';
        }
      }, 400);
    }

    lastY = y;
  }

  window.addEventListener('scroll', function(){
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function(){
        onScroll();
        ticking = false;
      });
    }
  }, { passive: true });

  /* NO initial call — Header 2 stays hidden until user scrolls */
})();
